module.exports = __webpack_public_path__ + "img/成都正好.5b0d0dc.png";